module.exports = __webpack_public_path__ + "static/why-liberalism-failed-ddadd8a1bd7efccbbeada7c11049d265.jpg";